export { VerticalDashes, HorizontalDashes } from './dashes';
